import {
  Competency_Map_Status,
  OrderType,
  PlatformCompetencyMapListOrderFields,
  useCompetencyMapOptionsQuery,
} from "@generated/graphql";

const useGetCompetencyMapOptions = () => {
  const { data: competencyMapsData, loading } = useCompetencyMapOptionsQuery({
    fetchPolicy: "cache-and-network",
    variables: {
      order: {
        field: PlatformCompetencyMapListOrderFields.CreatedAt,
        order: OrderType.Desc,
      },
      filter: {
        status: Competency_Map_Status.Approved,
      },
    },
  });

  return { competencyMapsOptions: competencyMapsData?.competencyMaps.data, loading };
};

export default useGetCompetencyMapOptions;
